// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3EwO7","colCheckbox":"styles_colCheckbox__3twy3"};